import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const sideAction = style({
  /** Keep the sidebar in shape when animated wrapper is transitioning */
  minWidth: 400
})

export const sideActionHeader = style({
  marginBottom: 10,
  display: 'flex',
  alignItems: 'center',
  gap: 16
})

export const sideActionTitleWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  marginRight: 'auto',
  minWidth: 0,
  gap: 3,
  marginBottom: 8
})

export const sideActionPicto = style({
  fontSize: 18,
  marginRight: 8,
  flexShrink: 0,
  color: vars.color.primary
})

export const sideActionTitle = style({
  margin: 0,
  fontSize: vars.font.h4.size,
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

export const sideActionLogo = style({
  display: 'block',
  width: 'auto',
  height: 26,
  objectFit: 'contain'
})

export const sideActionSubtitle = style({
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight
})

export const sideActionSubtitleLink = style({
  color: vars.color.primary,
  cursor: 'pointer',
  transition: 'color 0.2s',

  ':hover': {
    color: vars.color.primaryAlt
  }
})

export const sideActionDetailList = style({
  padding: 13,
  backgroundColor: vars.blocks.modale.background,
  color: vars.color.dark,
  borderRadius: vars.blocks.largeRadius,
  boxShadow: vars.shadowLight,
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 2,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
})

export const sideActionDetailListHeader = style({
  fontSize: vars.font.h3.size,
  fontWeight: vars.font.h3.weight,
  marginBottom: 13
})

export const sideActionDetailListHeaderCount = style({
  color: vars.color.primary
})

export const sideActionDetailListWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: `${vars.color.mediumDarker} transparent`,
  position: 'relative'
})

export const sideActionDetailListItem = style({
  padding: '12px 11px',
  backgroundColor: vars.color.drawBackgroundLighter,
  borderRadius: vars.blocks.radius,
  fontSize: 14,
  fontWeight: vars.font.bodyBold.weight,
  cursor: 'pointer',
  transition: 'background-color 0.2s',

  selectors: {
    '&:hover': {
      backgroundColor: vars.color.mediumLighter
    }
  }
})
